import defaultClient from '@src/api/clients/default';
import { bust as bustBudgetCenterCache, put as putBudgetCenterCache } from './budgetCenterCache';

export function fetchBudgetPacing(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/pacing/',
    payload,
  });
}

export function fetchBudgetPacingOverall(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/pacing-overall/',
    payload,
  });
}

export function fetchBudgetPacingSegments(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/pacing-segments/',
    payload,
  });
}

export function fetchBudgetPacingVerticals(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/pacing-verticals/',
    payload,
  });
}

export function fetchBudgetCenter(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/',
    payload,
  }).then((resp) => {
    putBudgetCenterCache('bc', payload, resp?.data);
    return resp;
  });
}

export function saveBudgetCenterDraft(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/save-draft/',
    method: 'POST',
    payload,
  }).then((resp) => {
    putBudgetCenterCache('bc', payload, resp?.data);
    return resp;
  });
}

export function approveBudgetCenter(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/approve/',
    method: 'POST',
    payload,
  }).then((resp) => {
    putBudgetCenterCache('bc', payload, resp?.data);
    return resp;
  });
}

export function discardBudgetCenterDraft(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/discard/',
    method: 'POST',
    payload,
  }).then((resp) => {
    putBudgetCenterCache('bc', payload, resp?.data);
    return resp;
  });
}

export function markBudgetCenterLive(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/mark-live/',
    method: 'POST',
    payload,
  }).then((resp) => {
    putBudgetCenterCache('bc', payload, resp?.data);
    return resp;
  });
}

// Undo the whole pending turn-off batch for a client + period. All-or-nothing
// by design: the hold window is debounced per client, so one countdown covers
// every segment in it. 400s once the batch has executed.
export function cancelBudgetCenterTurnOff(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/cancel-turn-off/',
    method: 'POST',
    payload,
  }).then((resp) => {
    putBudgetCenterCache('bc', payload, resp?.data);
    return resp;
  });
}

export function fetchAvailableMonths(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/available-months/',
    payload,
  });
}

export function copyFromMonth(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/copy-from-month/',
    method: 'POST',
    payload,
  }).then((resp) => {
    bustBudgetCenterCache({ client_id: payload.client_id, period: payload.target_period });
    return resp;
  });
}

export function fetchBudgetComments(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/comments/',
    payload,
  });
}

export function postBudgetComment(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/comments/',
    method: 'POST',
    payload,
  });
}

// Batched payloads (+ vertical/territory options) for every client under a
// parent company in ONE request — the parent view used to fan out 3 requests
// per child client. Also warms the per-client bc cache for drill-ins.
export function fetchBudgetCenterPortfolio(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/portfolio/',
    payload,
  }).then((resp) => {
    (resp?.data?.clients || []).forEach((entry) => {
      putBudgetCenterCache(
        'bc',
        { client_id: String(entry.client_id), period: resp.data.period },
        entry.payload,
      );
    });
    return resp;
  });
}

export function fetchBudgetCenterScopeSpend(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/scope-spend/',
    payload,
  }).then((resp) => {
    putBudgetCenterCache('scope', payload, resp?.data);
    return resp;
  });
}

export function fetchBudgetSubmissions(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/submissions/',
    payload,
  });
}

export default {
  fetchBudgetPacing,
  fetchBudgetPacingOverall,
  fetchBudgetPacingSegments,
  fetchBudgetPacingVerticals,
  fetchBudgetCenter,
  fetchBudgetCenterPortfolio,
  saveBudgetCenterDraft,
  approveBudgetCenter,
  discardBudgetCenterDraft,
  markBudgetCenterLive,
  fetchAvailableMonths,
  copyFromMonth,
  fetchBudgetComments,
  postBudgetComment,
  fetchBudgetSubmissions,
};
